import { render, staticRenderFns } from "./SetupOrderOptions.vue?vue&type=template&id=8200566c&"
import script from "./SetupOrderOptions.vue?vue&type=script&lang=js&"
export * from "./SetupOrderOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports